import axiosService from '../../services/axios/axios.service';
import { AttendancesResponse } from '../../models/attendance';

const getAttendances = async (
    date?: Date,
    checkedIn?: string
): Promise<NonNullable<AttendancesResponse>> => {
    const response = await axiosService.get(
        `/attendance/get-attendances?attendanceDate=${date}&checkedIn=${checkedIn}`
    );
    return response.data;
};

const updateAttendance = async ({
    uid,
    checkTime,
    attendanceId,
    date,
}: {
    uid: string;
    checkTime: string;
    attendanceId?: string;
    date?: string;
}) => {
    const response = await axiosService.post(`/attendance/update-attendance`, {
        uid,
        checkTime,
        attendanceId,
        date,
    });
    return response.data;
};

export { getAttendances, updateAttendance };
